import { Navigate, Route, Routes } from 'react-router-dom';

import { AdminRoute, hasValidSession, PrivateRoute } from './components/private-route';
import { AppLayout } from './layouts/app-layout';
import { GuestAmazonLayout } from './layouts/guest-amazon-layout';
import { AmazonPage } from './pages/amazon-page';
import { AmazonProductsPage } from './pages/amazon-products-page';
import { BusinessInformationPage } from './pages/business-information-page';
import { DownloadsPage } from './pages/downloads-page';
import { ExpensesPage } from './pages/expenses-page';
import { FilesPage } from './pages/files-page';
import { LoginPage } from './pages/login-page';
import { LogsPage } from './pages/logs-page';
import { MeeshoCropperPage } from './pages/meesho-cropper-page';
import { ProfilePage } from './pages/profile-page';
import { SupplierCatalogPage } from './pages/supplier-catalog-page';
import { SupplierDetailPage } from './pages/supplier-detail-page';
import { SupplierFollowUpsPage } from './pages/supplier-follow-ups-page';
import { SupplierSettingsPage } from './pages/supplier-settings-page';
import { SuppliersPage } from './pages/suppliers-page';
import { UsersPage } from './pages/users-page';
import { VectorCadPage } from './pages/vector-cad-page';
import { useAuthStore } from './stores/auth-store';

export default function App() {
  const user = useAuthStore((state) => state.user);
  const amazonAccessMode = user && hasValidSession() ? 'authenticated' : 'guest';

  return (
    <Routes>
      <Route path='/login' element={<LoginPage />} />
      <Route
        path='/amazon'
        element={
          amazonAccessMode === 'authenticated' ? (
            <AppLayout>
              <AmazonPage accessMode='authenticated' />
            </AppLayout>
          ) : (
            <GuestAmazonLayout>
              <AmazonPage accessMode='guest' />
            </GuestAmazonLayout>
          )
        }
      />
      <Route element={<PrivateRoute />}>
        <Route element={<AppLayout />}>
          <Route path='/files' element={<FilesPage />} />
          <Route path='/downloads' element={<DownloadsPage />} />
          <Route path='/amazon/products' element={<AmazonProductsPage />} />
          <Route path='/meesho-cropper' element={<MeeshoCropperPage />} />
          <Route path='/laser-studio' element={<VectorCadPage />} />
          <Route path='/expenses' element={<ExpensesPage />} />
          <Route path='/business-information' element={<BusinessInformationPage />} />
          <Route path='/suppliers' element={<SuppliersPage />} />
          <Route path='/suppliers/:id' element={<SupplierDetailPage />} />
          <Route path='/suppliers/follow-ups' element={<SupplierFollowUpsPage />} />
          <Route path='/suppliers/products' element={<SupplierCatalogPage />} />
          <Route path='/profile' element={<ProfilePage />} />
          <Route element={<AdminRoute />}>
            <Route path='/logs' element={<LogsPage />} />
            <Route path='/users' element={<UsersPage />} />
            <Route path='/suppliers/settings' element={<SupplierSettingsPage />} />
          </Route>
        </Route>
      </Route>
      <Route path='*' element={<Navigate to={user ? '/files' : '/login'} replace />} />
    </Routes>
  );
}
